<template>
  <!-- <q-layout class="bg-black"> -->
  <div class="column" style="height: 100vh; width: 100vm; position: relative">
    <q-icon
      v-if="showFullscreenIcon && isWeb"
      class="absolute"
      style="top: 5px; right: 13px; z-index: 1"
      @click="$q.fullscreen.toggle()"
      :name="$q.fullscreen.isActive ? 'fullscreen_exit' : 'fullscreen'"
      size="40px"
    />

    <template v-if="!domainControlStore.isConnected && !isDev">
      <div
        class="column justify-center items-center content-center text-secondary q-gutter-md"
        style="flex: 1"
      >
        <template v-if="!isSupportBluetooth">
          <q-icon name="mobile_off" color="teal" size="4.4em" />
          <span class="text-h6">当前设备不支持蓝牙 </span>
        </template>
        <template v-else>
          <span class="text-h6"> OTA更新 </span>
          <q-icon name="bluetooth_disabled" color="teal" size="4.4em" />
          <span class="text-h6">蓝牙未连接 </span>
          <span class="text-weight-bold">
            <q-btn
              outline
              rounded
              size="lg"
              :loading="!!loading[0]"
              @click="connectToDevice"
              style="min-width: 200px"
            >
              {{ domainControlStore.isConnected ? "已连接" : "链接蓝牙" }}
              <template v-slot:loading>
                <q-spinner-hourglass class="on-left" />
                Loading...
              </template>
            </q-btn>
          </span>
        </template>
      </div>
    </template>
    <template v-else>
      <Layout>
        <template #header> 更新 </template>
        <div class="column full-height" style="flex: 1">
          <q-card bordered class="full-height column">
            <q-card-section
              class="column items-center q-gutter-y-md"
              style="flex: 1"
            >
              <div
                class="column full-height justify-center items-center content-center text-secondary q-gutter-md"
              >
                <template v-if="isError">
                  <span class="text-h4 text-red"
                    >更新失败 请刷新页面后重试</span
                  >
                </template>
                <!-- <template v-if="isMatchMD5">
                    <span class="text-h4 text-green">
                      软件已是最新版本 无需更新
                    </span>
                  </template> -->
                <template v-else>
                  <div class="text-h5 q-mb-md">
                    更新过程中请勿断电或断开蓝牙连接
                  </div>
                  <!-- :disable="isMatchMD5" -->
                  <q-btn
                    :loading="!!loading[1]"
                    color="green"
                    glossy
                    rounded
                    :disable="isMatchMD5"
                    size="lg"
                    @click="handleUpdateSoftware"
                  >
                    更新软件
                    {{ isMatchMD5 ? "(软件已是最新版本 无需更新)" : "" }}
                  </q-btn>
                  <q-btn
                    :loading="!!loading[1]"
                    color="red"
                    glossy
                    rounded
                    size="lg"
                    @click="handleUpdateFirmware"
                  >
                    更新固件
                  </q-btn>
                </template>
              </div>
              <q-dialog
                position="standard"
                :model-value="loading[0]"
                persistent
              >
                <!-- <div class="q-pa-md row items-center q-gutter-md"  style="width: 50%"> -->
                <q-card class="my-card" style="width: 60%; height: 300px">
                  <q-card-section
                    class="column full-height justify-center items-center content-center text-secondary"
                  >
                    <div class="text-h4 q-mb-md">更新中</div>
                    <div class="text-h5 q-mb-md">请勿断电或断开蓝牙连接</div>
                    <div class="text-h6 q-mb-md">
                      大约需要{{ updateType === "software" ? 1 : 5 }}分钟
                    </div>
                    <div class="text-h6 q-mb-md">状态： {{ progress }}</div>
                    <q-linear-progress
                      indeterminate
                      stripe
                      rounded
                      size="20px"
                      :value="100"
                      color="blue"
                      class="q-mt-sm"
                    />
                  </q-card-section>
                </q-card>
              </q-dialog>
            </q-card-section>
          </q-card>
        </div>
      </Layout>
    </template>
  </div>
</template>

<script setup lang="ts">
import "quasar/dist/quasar.css";
import "../../assets/styles/quasar.scss";
import "@quasar/extras/material-icons/material-icons.css";
import { isWeb } from "@/utils/env";
import { isSupportBluetooth } from "@/utils/bluetooth";
import { ref, onMounted, onUnmounted, computed, watch } from "vue";
// import ICC from "./ICC.vue";
import { useQuasar } from "quasar";
// import { ESP32BLEBluetooth } from "@/services/domainControl";
// import { BleDevice } from "@capacitor-community/bluetooth-le";
import { useDomainControlStore } from "@/stores/domainControl";
import BluetoothContorller from "./components/BluetoothContorller.vue";
import Layout from "./components/Layout.vue";
import {
  checkFirmware,
  firmwareFiles,
  fetchUpdateFileList,
  readFileMD5,
  resetFactory,
  updateReset,
  uploadSoftware,
  uploadSoftwareBuffer,
  uploadFileMD5,
  uploadFirmware,
  writeData,
} from "@/services/domainControl/ESP32Update";
import MD5 from "crypto-js/md5";
import {
  arrayBufferToBase64,
  getByteLength,
  getTextByteLength,
  md5ArrayBuffer,
  splitFilesByArrayBufferSize,
  splitFilesBySize,
} from "./helper/update";
import { useRoute, useRouter } from "vue-router";

// route
const route = useRoute();
const router = useRouter();
const showFullscreenIcon = computed(() => {
  // return !["DUR", "DMC"].includes(route.name as any); // 根据需要调整路由名称
  return true;
});

// dark mode
const $q = useQuasar();
// $q.dark.set(true);

const domainControlStore = useDomainControlStore();

const isDev = import.meta.env.VITE_NODE_ENV === "development";

const loading = ref([] as boolean[]);
const fileList = ref([] as DomianControl.UpdateFileItem[]);
const isError = ref(false);
const isMatchMD5 = ref(false); // 是否匹配 md5 false 不匹配需要更新
const progress = ref("等待中");
const updateType = ref("software"); // software 软件 update 固件

// 固件文件
const firmwareFileList = computed(() => {
  return fileList.value.filter((item) =>
    firmwareFiles.includes(item.file_name)
  );
});
// 软件文件
const softwareFileList = computed(() => {
  return fileList.value.filter(
    (item) => !firmwareFiles.includes(item.file_name)
  );
});
// 软件文件 字符串 （其中二进制文件转为 base64）
const softwareStringFileList = computed(() => {
  return softwareFileList.value.map((item) => {
    if (item.file_content instanceof ArrayBuffer) {
      return {
        ...item,
        file_content: arrayBufferToBase64(item.file_content as ArrayBuffer),
      };
    }
    return item;
  });
});
// // 软件文件 二进制
// const softwareBinaryFileList = computed(() => {
//   return softwareFileList.value.filter(
//     (item) => item.file_content instanceof ArrayBuffer
//   );
// });

watch(softwareFileList, (newVal) => {
  // 计算一下分别每个文件的 内容字节大小
  newVal.map((item) => {
    console.log(
      "[BOWEN_LOG] 🚀 ~ 软件文件:",
      item.file_name,
      item.file_content instanceof ArrayBuffer
        ? item.file_content.byteLength
        : getTextByteLength(item.file_content as any as string)
    );
  });
});

// 固件 md5
const getFirmwareMD5List = () => {
  const fileMD5List = firmwareFileList.value.map((item) => {
    return {
      file_name: item.file_name,
      file_md5:
        (item.file_content as any) instanceof ArrayBuffer
          ? md5ArrayBuffer(item.file_content as any as ArrayBuffer)
          : MD5(item.file_content as any as string).toString(),
    } as DomianControl.UpdateFileMD5Item;
  });
  return fileMD5List;
};
// 软件 md5
const getSoftwareMD5List = () => {
  const fileMD5List = softwareFileList.value.map((item) => {
    return {
      file_name: item.file_name,
      file_md5:
        (item.file_content as any) instanceof ArrayBuffer
          ? md5ArrayBuffer(item.file_content as any as ArrayBuffer)
          : MD5(item.file_content as any as string).toString(),
    } as DomianControl.UpdateFileMD5Item;
  });
  return fileMD5List;
};
// 软件二进制转为字符串后的 md5
const getSoftwareStringMD5List = () => {
  const fileMD5List = softwareStringFileList.value.map((item) => {
    return {
      file_name: item.file_name,
      file_md5:
        (item.file_content as any) instanceof ArrayBuffer
          ? md5ArrayBuffer(item.file_content as any as ArrayBuffer)
          : MD5(item.file_content as any as string).toString(),
    } as DomianControl.UpdateFileMD5Item;
  });
  return fileMD5List;
};
// 更新固件
const handleUpdateFirmware = async () => {
  updateType.value = "firmware";
  progress.value = "等待中";
  loading.value[0] = true;
  try {
    const res = await checkFirmware();
    console.log(
      "[BOWEN_LOG] 🚀 ~~ 更新固件 是否允许更新固件 0代表成功。-1代表失败:",
      res
    );
    // 0代表成功。-1代表失败
    // if (res?.code !== 0) {
    //   $q.notify("返回出厂设置中");
    //   resetFactory();
    //   loading.value[0] = false;
    //   return;
    // }
    const fileMD5List = getFirmwareMD5List();
    console.log("[BOWEN_LOG] 🚀 ~~ 更新固件 md5:", fileMD5List);
    progress.value = "分片固件上传中";
    // 分片固件
    await handleSliceFirmware();
    progress.value = "发送md5列表";
    // 发送 md5列表
    await uploadFileMD5(fileMD5List);
    progress.value = "重启中";
    // 重启
    await updateReset();
    await new Promise((resolve) => setTimeout(resolve, 60000)); // 等一分钟
  } catch (error) {
    isError.value = true;
    console.log("[BOWEN_LOG] 🚀 ~~ 更新固件 ~~ error:", error);
  }
  loading.value[0] = false;
};

// 更新软件
const handleUpdateSoftware = async () => {
  updateType.value = "software";
  progress.value = "等待中";
  loading.value[0] = true;

  try {
    console.log("[BOWEN_LOG] 🚀 ~~ fileMD5List ~~ fileList:", fileList.value);

    const fileMD5List = getSoftwareStringMD5List();
    console.log("[BOWEN_LOG] 🚀 ~~ 更新软件 md5:", fileMD5List);

    progress.value = "分片上传文件";
    // 分片上传文件
    await handleSliceSoftware();
    progress.value = "发送md5列表";

    // 发送 md5列表
    const res = await uploadFileMD5(fileMD5List);
    console.log("[BOWEN_LOG] 🚀 ~~ 更新软件 ~~ 发送 md5列表 res :", res);
    progress.value = "重启中";
    // 重启
    const res2 = await updateReset();
    console.log("[BOWEN_LOG] 🚀 ~~ 更新软件 ~~ 重启 res2:", res2);
  } catch (error) {
    isError.value = true;
    console.log("[BOWEN_LOG] 🚀 ~~ 更新软件 ~~ error:", error);
  }
  loading.value[0] = false;
};

// 分片上传软件
const handleSliceSoftware = async () => {
  // 过滤二进制文件
  const files = softwareStringFileList.value;
  console.log("[BOWEN_LOG] 🚀 ~~ handleSliceSoftware ~~ files:", files);
  const res = splitFilesBySize(files as any, 500 - 200);
  console.log("[BOWEN_LOG] 🚀 ~ 分片软件:", res);
  for (const item of res) {
    await uploadSoftware(item);
    // await new Promise((resolve) => setTimeout(resolve, 500, true));
    const encoder = new TextEncoder();
    console.log(
      "[BOWEN_LOG] 🚀 ~~ 分片软件 ",
      item.file_name,
      encoder.encode(item.file_content).byteLength,
      encoder.encode(JSON.stringify(item)).byteLength
    );
    if (encoder.encode(JSON.stringify(item)).byteLength > 500) {
      console.warn(
        item.file_name,
        "文件过大",
        encoder.encode(JSON.stringify(item)).byteLength
      );
    }
  }

  // // 分片二进制
  // const binaryFiles = softwareBinaryFileList.value;
  // const res2 = splitFilesByArrayBufferSize(binaryFiles as any, 500 - 200);
  // console.log(
  //   "[BOWEN_LOG] 🚀 ~~ 分片软件二进制: binaryFiles res2",
  //   res2,
  //   binaryFiles
  // );

  // for (const item of res2) {
  //   await uploadSoftware(item);
  //   await new Promise((resolve) => setTimeout(resolve, 30, true));
  //   const encoder = new TextEncoder();
  //   console.log(
  //     "[BOWEN_LOG] 🚀 ~~ 分片软件二进制 ",
  //     item.file_name,
  //     item.file_content.byteLength,
  //     encoder.encode(JSON.stringify(item)).byteLength
  //   );
  //   if (encoder.encode(JSON.stringify(item)).byteLength > 500) {
  //     console.warn(
  //       item.file_name,
  //       "文件过大",
  //       encoder.encode(JSON.stringify(item)).byteLength
  //     );
  //   }
  // }
};

// 分片固件
const handleSliceFirmware = async () => {
  const res = splitFilesByArrayBufferSize(
    firmwareFileList.value as any,
    500 - 100
  );
  console.log("[BOWEN_LOG] 🚀 ~~ 分片固件:", res);
  for (const item of res) {
    await uploadFirmware(item.file_content as ArrayBuffer);
    await new Promise((resolve) => setTimeout(resolve, 30, true));
    console.log(
      "[BOWEN_LOG] 🚀 ~~ 分片固件 ",
      item.file_name,
      item.file_content.byteLength
    );
    if (item.file_content.byteLength > 500) {
      console.warn(item.file_name, "文件过大", item.file_content.byteLength);
    }
  }
};

const fetchFiles = async () => {
  loading.value[1] = true;
  try {
    fileList.value = await fetchUpdateFileList();
    handleCompareMD5();
  } catch (error) {
    isError.value = true;
  }
  loading.value[1] = false;
};

// 对比 md5
const handleCompareMD5 = async () => {
  try {
    const res = await readFileMD5();
    console.log("[BOWEN_LOG] 🚀 ~~ 获取 esp32 md5:", res);
    if (!res || Object.keys(res).length === 0) return;
    const fileMD5List = getSoftwareMD5List();
    console.log("[BOWEN_LOG] 🚀 ~~ 获取 线上 md5:", fileMD5List);
    // 以 fileMD5List 为准 对比 res  如果 res 中没有 file_name 则认为不同
    const isSame = fileMD5List.every((item, index) => {
      if (!res[item.file_name]) return false;
      return item.file_md5 === res[item.file_name];
    });
    console.log("[BOWEN_LOG] 🚀 ~~ esp32 与 线上 md5 对比是否相同:", isSame);
    isMatchMD5.value = isSame;
  } catch (error) {
    isMatchMD5.value = false;
  }
};

const handleDisconnected = async () => {
  domainControlStore.changeIsConnectedStatus(false);
  $q.notify("蓝牙已断开连接");
  loading.value[0] = false;
  // router.push({ name: "Home" });
};
// 链接蓝牙
const connectToDevice = async () => {
  await domainControlStore.connectToDevice(
    handleDisconnected,
    loading,
    route.name?.toString()
  );
  // handleUpdateSoftware();
};
const handleBeforeunload = (event: any) => {
  domainControlStore.disconnectDevice();
};

onMounted(async () => {
  fetchFiles();
  domainControlStore.pageMounted(handleDisconnected); // hot-update
  window.addEventListener("beforeunload", handleBeforeunload);
  document.title = "OTA更新";
});
onUnmounted(() => {
  domainControlStore.disconnectDevice();
  window.removeEventListener("beforeunload", handleBeforeunload);
});

// 与 beforeRouteUpdate 相同，无法访问 `this`fetchUpdateFileList
// onBeforeRouteUpdate(async (to, from) => {
//   console.log("[BOWEN_LOG] 🚀 ~~ onBeforeRouteUpdate ~~ to, from:", to, from);
//   //仅当 id 更改时才获取用户，例如仅 query 或 hash 值已更改
// });
</script>
